require("!!/Users/gautierfauchart/Ethereum/Ethdev-RPS/node_modules/script-loader/addScript.js")(require("!!/Users/gautierfauchart/Ethereum/Ethdev-RPS/node_modules/raw-loader/index.js!/Users/gautierfauchart/Ethereum/Ethdev-RPS/node_modules/phaser-ce/build/custom/p2.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/phaser-ce/build/custom/p2.js
// module id = 91
// module chunks = 3